import { createContext } from "react"
import { initial_sidebar } from "./reducer"
import { SidebarContext as SidebarContextType } from "./types"

const SidebarContext = createContext<SidebarContextType>({ sidebar: initial_sidebar, dispatch: () => null})
export default SidebarContext
